<template>
    <div></div>
</template>

<script>
import BelowEntryForm from './BelowEntryForm.js';
export default BelowEntryForm;
</script>
